/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins, fonts } from '@blend/consumer-components';
import { BrandColors } from '@blend/enterprise-components';

export namespace SidebarContent {
  export interface Props {
    title: string;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    height: '100%',
    width: 274,
    backgroundColor: BrandColors.WHITE,
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.white,
    fontSize: 18,
    height: 48,
    ...fonts.UntitledSans,
    ...mixins.padding(0, 0, 0, 8),
  },
});

export const SidebarContent: React.FC<SidebarContent.Props> = ({ title, children }) => {
  return (
    <div className={css(styles.wrapper)} data-it="SidebarContent">
      <div className={css(styles.titleWrapper)}>{title}</div>
      {children}
    </div>
  );
};
